<template>
  <v-snackbar
    v-model="showMessage"
    :timeout="timeout"
    :color="message.type"
    style="z-index: 1000000;"
  >
    {{ message.text }}
    <v-btn
      icon
      dark
      text
      @click.native="showMessage = false"
    >
      <v-icon>fa-times</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
  export default {
    data: function () {
      return {
        showMessage: false
      }
    },
    computed: {
      message () {
        return this.$store.getters.message
      },
      timeout () {
        if (this.message && this.message != null && this.message.clickToDismiss) {
          return 0
        } else {
          return 6000
        }
      }
    },
    watch: {
      message: {
        handler: function () {
          if (this.message.translate) {
            this.message.text = this.$t(this.message.text)
          }
          if (this.message.show) {
            this.showMessage = true
          }
        },
        deep: true
      },
      showMessage: function () {
        if (!this.showMessage) {
          this.$store.commit('hideMessage')
        }
      }
    }
  }
</script>
